import axios from "axios";
import {
    GET_SOURCE_COMBINATION_LIST,
    GET_SOURCE_COMBINATION_LIST_LOADING,
    GET_SOURCE_COMBINATION_LIST_FAILD,
} from "../type/type";
const PROXY = process.env.REACT_APP_API_URL + 'api/lbc/';

export const createCombination = (data) => async (dispatch) => {
    const res = await axios.post(PROXY + "source", data);
    return res;
}

export const getAllLeads = (queryObject) => async (dispatch) => {
    try {
        dispatch({ type: GET_SOURCE_COMBINATION_LIST_LOADING });
        const res = await axios.get(PROXY + 'source-list', { params: queryObject });
        dispatch({
            type: GET_SOURCE_COMBINATION_LIST,
            payload: res.data.result,
        });
        return res;
    } catch (err) {
        dispatch({ type: GET_SOURCE_COMBINATION_LIST_FAILD });
        return err
    }
};

export const getSpecificCombination = (id) => async (dispatch) => {
    const res = await axios.get(PROXY + "source/" + id);
    return res;
};

export const editCombination = (id, data) => async (dispatch) => {
    const res = await axios.put(PROXY + 'source/' + id, data)
    return res
}

export const deleteCombination = (id) => async (dispatch) => {
    const res = await axios.delete(PROXY + 'source/' + id)
    return res
}